export const APP_MIN_VERSION = '1.3.0'
export const Config = {
  buildNumber: '%BUILD_NUMBER%',
  version: '1.5.0'
}
